__turbopack_context__.v({
  "active": "messaging-tools-module-sass-module__uXEVwa__active",
  "checkbox": "messaging-tools-module-sass-module__uXEVwa__checkbox",
  "closeBtn": "messaging-tools-module-sass-module__uXEVwa__closeBtn",
  "delete": "messaging-tools-module-sass-module__uXEVwa__delete",
  "disabled": "messaging-tools-module-sass-module__uXEVwa__disabled",
  "messagingTools": "messaging-tools-module-sass-module__uXEVwa__messagingTools",
  "searchBtn": "messaging-tools-module-sass-module__uXEVwa__searchBtn",
  "searchField": "messaging-tools-module-sass-module__uXEVwa__searchField",
  "searchInputVisible": "messaging-tools-module-sass-module__uXEVwa__searchInputVisible",
  "starred": "messaging-tools-module-sass-module__uXEVwa__starred",
});
